const normalizeEffectAreaForBuff = (raw = "") => {
  const normalized = String(raw).trim().toLowerCase().replace(/\s+/g, "");
  if (
    normalized === "turnloss" ||
    normalized === "turnskip" ||
    normalized === "skippedturns"
  ) {
    return "turnLoss";
  }
  if (normalized.startsWith("def")) return "defense";
  if (normalized.startsWith("acc")) return "accuracy";
  if (normalized.startsWith("atk") || normalized.startsWith("att")) {
    return "attack";
  }
  if (normalized.startsWith("hp") || normalized.startsWith("health")) {
    return "health";
  }
  return normalized;
};

export const buildOngoingCardBuff = ({
  area,
  amount,
  duration,
  card = null,
  sourcePlayer = null,
}) => {
  const normalizedArea = normalizeEffectAreaForBuff(area);
  const numericAmount = Number(amount ?? 0);
  const numericDuration = Number(duration ?? 0);
  const adjustedDuration =
    normalizedArea === "health" && numericAmount < 0
      ? Math.max(numericDuration - 1, 0)
      : numericDuration;
  const shouldStoreBuff =
    adjustedDuration > 0 ||
    normalizedArea === "attack" ||
    normalizedArea === "accuracy";

  if (!shouldStoreBuff) {
    return null;
  }

  const buff = {
    amt: numericAmount,
    duration: adjustedDuration,
  };

  if (card?.imageUrl) {
    buff.icon = card.imageUrl;
  }
  if (card?.name) {
    buff.name = card.name;
  }
  if (normalizedArea === "health" && numericAmount < 0) {
    buff.source = {
      id: sourcePlayer?.id || null,
      name: sourcePlayer?.name || "Player",
      character: sourcePlayer?.character?.name || "Character",
      cardName: card?.name || null,
      appliedAt: Date.now(),
    };
  }

  return buff;
};
